import SuccessView from './SuccessView';
export default SuccessView;
